import React from 'react';
import LocalizedStaticPage from './LocalizedStaticPage';

const PartnershipPage = () => <LocalizedStaticPage page="partnership" />;
export default PartnershipPage;
